import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

// Three horizontal slider rails with round knobs. Lucide's sliders-horizontal
// uses small perpendicular line segments as knobs; this variant swaps them for
// circles per design preference. Rails break around the circles so the stroke
// reads cleanly at small sizes.
const SlidersHorizontalIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="3" y1="5" x2="12" y2="5" />
    <line x1="16" y1="5" x2="21" y2="5" />
    <circle cx="14" cy="5" r="2" />
    <line x1="3" y1="12" x2="6" y2="12" />
    <line x1="10" y1="12" x2="21" y2="12" />
    <circle cx="8" cy="12" r="2" />
    <line x1="3" y1="19" x2="14" y2="19" />
    <line x1="18" y1="19" x2="21" y2="19" />
    <circle cx="16" cy="19" r="2" />
  </ChakraIcon>
)

export default SlidersHorizontalIcon
